import React from "react";
import { PageHero } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    h: "Our Confidentiality Pledge",
    p: "Bright Stories Network is built privacy-first. We do not sell, rent, or trade your personal information. We collect only what is necessary to operate the site and fulfill downloads or donations you request.",
  },
  {
    h: "Information We Collect",
    p: "When you make a purchase or donation, payment is processed securely by Stripe; we never store your full card details. If you submit a story or contact message, we store only what you choose to share with us.",
  },
  {
    h: "How We Use Information",
    p: "To deliver your downloads, process donations, respond to your messages, and — only with your explicit consent — to share survivor stories anonymously to encourage others.",
  },
  {
    h: "Cookies & Tracking",
    p: "We keep tracking to a respectful minimum. Essential functionality (like your shopping cart) is stored locally in your browser and is never transmitted for advertising purposes.",
  },
  {
    h: "Terms of Service",
    p: "Bright Stories Network is provided for supportive and educational purposes. Digital products are licensed for personal, non-commercial use. Content may not be resold or redistributed without written permission.",
  },
  {
    h: "Crisis Support Disclaimer",
    p: "Bright Stories Network is NOT a crisis hotline, emergency service, or substitute for professional medical or mental-health care. If you are in crisis, call or text 988 (US & Canada), or 911 if there is immediate danger. Internationally, visit findahelpline.com.",
  },
  {
    h: "Accessibility Commitment",
    p: "We strive to meet modern accessibility standards, including keyboard navigation, sufficient color contrast, reduced-motion support, and screen-reader-friendly structure. If you encounter a barrier, please contact us so we can make it right.",
  },
];

export default function Legal() {
  return (
    <div data-testid="legal-page">
      <PageHero
        eyebrow="Privacy & Terms"
        title="Your trust, carefully protected"
        subtitle="Transparency about how we handle your information, our terms of use, and important crisis-support notices."
        testid="legal-hero"
      />
      <section className="max-w-3xl mx-auto px-4 py-16 sm:py-20 space-y-10">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.h} delay={i * 50}>
            <div data-testid={`legal-section-${i}`}>
              <h2 className="font-serif text-2xl font-semibold text-bsn-midnight flex items-center gap-3">
                <span className="w-7 h-px bg-bsn-gold" /> {s.h}
              </h2>
              <p className="mt-3 text-bsn-sapphire/85 leading-relaxed">{s.p}</p>
            </div>
          </Reveal>
        ))}
        <p className="text-sm text-bsn-sapphire/60 pt-6 border-t border-bsn-gold/20">
          Last updated June 2026 · Bright Stories Network · Hosted with care on Hostinger.
        </p>
      </section>
    </div>
  );
}
